import React from "react";
import { getProfileImageUrl } from "../utils/profileImage";

type Props = {
  user: any;
};

const ProfileAvatar: React.FC<Props> = ({ user }) => {
  if (!user)
    return null;

  const imageToShow = getProfileImageUrl(user.profileUrl);

  return (
    <div className="profile-avatar-wrapper">
      <img
        src={imageToShow}
        alt="profile"
        className="profile-avatar-img"
      />
    </div>
  );
};

export default ProfileAvatar;
